import { useState } from "react";
import { Cpu, HardDriveDownload, Stethoscope, KeyRound } from "lucide-react";
import { runSaharaRead, runSaharaDiag, runSaharaUnlock } from "../lib/serial";
import { saveBinaryWithPicker } from "../lib/saveAs";

const VARIANTS = ["k0", "byte dibalik", "k0 +1", "k0 −1"];

export const SaharaReadPanel = ({ manager, log, onProgress, disabled, ensureBridge }) => {
  const [busy, setBusy] = useState(false);
  const [variant, setVariant] = useState(0);
  const withBridge = async (fn) => {
    setBusy(true);
    try {
      try { await ensureBridge(); } catch (e) { log("ERROR", `Bridge/Tactrix connect failed: ${e.message}`); return; }
      await fn();
    } finally { setBusy(false); }
  };
  const run = (probe) => withBridge(async () => {
    const r = await runSaharaRead(manager, { probe, variant }, { onLog: log, onProgress });
    if (r.bytes) await saveBinaryWithPicker(r.bytes, "SAHARA300-K3H-read-768KB.bin", { onLog: log });
  });
  const diag = () => withBridge(() => runSaharaDiag(manager, { onLog: log }));
  const access = () => withBridge(() => runSaharaUnlock(manager, { variant }, { onLog: log }));
  const btn = "flex-1 h-9 rounded-lg font-bold text-[13px] inline-flex items-center justify-center gap-2 disabled:opacity-50 transition-colors";
  return (
    <div data-testid="sahara-read-panel" className="rounded-md border-2 border-[#4b505b] bg-[#0f1115] p-3 flex flex-col gap-2 shrink-0">
      <div className="text-white font-bold text-[13px]">Denso Sahara 300 · CAN (Tactrix) · READ only</div>
      <div className="flex items-center gap-2">
        <span className="text-[11px] text-gray-400 shrink-0">Varian key</span>
        <div className="grid grid-cols-4 gap-1 flex-1">
          {VARIANTS.map((v, i) => (
            <button key={i} data-testid={`sahara-variant-${i}`} disabled={busy || disabled} onClick={() => setVariant(i)}
              className={`h-7 rounded text-[11px] font-bold border transition-colors ${variant === i ? "border-amber-500 bg-amber-500/15 text-amber-300" : "border-[#4b505b] text-gray-300 hover:bg-white/5"}`}>{v}</button>
          ))}
        </div>
      </div>
      <div className="text-[10px] text-gray-500 leading-tight">Ada jeda ~12 dtk (anti-scan) sebelum key dikirim; jika terkunci, bridge menunggu lalu coba ulang 1×. Jika tetap gagal: OFF→ON, ganti varian.</div>
      <div className="grid grid-cols-2 gap-2">
        <button data-testid="sahara-diagnose" disabled={busy || disabled} onClick={diag} className={`${btn} border border-[#4b505b] text-gray-200 hover:bg-white/5`}><Stethoscope size={16} /> Diagnose</button>
        <button data-testid="sahara-access" disabled={busy || disabled} onClick={access} className={`${btn} border border-amber-500 text-amber-300 hover:bg-amber-500/10`}><KeyRound size={16} /> Akses Read</button>
        <button data-testid="sahara-test-read" disabled={busy || disabled} onClick={() => run(true)} className={`${btn} border border-red-600 text-red-300 hover:bg-red-600/10`}><Cpu size={16} /> Test Read</button>
        <button data-testid="sahara-read-full" disabled={busy || disabled} onClick={() => run(false)} className={`${btn} bg-red-600 hover:bg-red-700 text-white`}><HardDriveDownload size={16} /> Read 768 KB</button>
      </div>
    </div>
  );
};
